import { useState, useEffect } from "react";
import TableTop from "../TableComponents/TableTop";
import { Table, TableBody } from "@mui/material";
import ActiveRequestsTableHead from "../TableHeads/ActiveRequestsTableHead";
import { useDispatch, useSelector } from "react-redux";
import { getActiveRequests } from "../../../reduxStore/entities/userCars";
import ActiveCarRequestTableRow from "../TableRows/ActiveCarRequestTableRow";

const ActiveRequestTable = ({
    id
}) => {
    const [isTableShown, setIsTableShown] = useState(true);

    const dispatch = useDispatch();

    const [loaded, setLoaded] = useState(false);

    const fetchedActiveCarRequests = useSelector((state) => state.userCars.activeRequests);
    const count = useSelector((state) => state.userCars.count);

    useEffect(() => {
        setLoaded(true);
    }, [fetchedActiveCarRequests]);

    useEffect(() => {
        dispatch(getActiveRequests(id));
    }, [id]);

    if (!loaded) {
        return null;
    };

    return (
        <div style={styles.mainContainer}>
            <TableTop
                title={"Aktivni zahtevi"}
                count={count}
                open={isTableShown}
                setOpen={setIsTableShown}
            />

            {isTableShown && (
                <div style={styles.tablePaddingDiv}>
                    <div style={styles.tableBorderDiv}>
                        <Table>
                            <ActiveRequestsTableHead />

                            <TableBody>

                                {fetchedActiveCarRequests.map((row, index) => (
                                    <ActiveCarRequestTableRow
                                        key={index}
                                        carRequest={row}
                                    />
                                ))}

                            </TableBody>

                        </Table>
                    </div>
                </div>
            )}

        </div>
    );
};


export default ActiveRequestTable;

const styles = {
    mainContainer: {

    },
    tablePaddingDiv: {
        paddingInline: 30,
    },
    tableBorderDiv: {
        borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
        borderRight: "1px solid rgba(0, 0, 0, 0.12)"
    }
};